<h1>{{ alert_data.header}}</h1>

<p>{{ alert_data.message }}</p>

<button mat-button [mat-dialog-close]>{{ alert_data.button }}</button>
